export const EXTERNAL_SYSTEM_NAMES = Object.freeze({
  DRILLPLAN: 'DrillPlan',
});

export const COMPANY_DATA_NODE_NAME = 'Company Data';
